export const categories: object = {
  categories: {
    all: 'All',
    browse: 'Browse',
    in: 'in',
    categories: 'Categories',
    'erp-and-finance': 'ERP and Finance',
    'crm-and-customer-experience': 'CRM and Customer Experience',
    'spend-management': 'Spend Management',
    'human-capital-management': 'Human Capital Management',
    'supply-chain-management': 'Supply Chain Management',
    'business-technology-platform': 'Business Technology Platform',
    'services-and-support': 'Services and Support',
    'training-and-adoption': 'Training and Adoption',
    'browse-all-categories': 'Browse All Categories',
    'browse-all-industries': 'Browse All Industries',
    'browse-all-solution-types': 'Browse All Solution Types',
    subCategories: {
      // ERP and Finance
      'all-in-erp-and-finance': 'All in ERP and Finance',
      'all-in-crm-and-customer-experience': 'All in CRM and Customer Experience',
      'all-in-spend-management': 'All in Spend Management',
      'all-in-supply-chain-management': 'All in Supply Chain Management',
      'all-in-human-capital-management': 'All in Human Capital Management',
      'all-in-business-technology-platform': 'All in Business Technology Platform',
      'sap-s-4hana': 'SAP S/4HANA',
      'erp-for-small-and-midsize-enterprises': 'ERP for Small and Midsize Enterprises',
      'financial-planning-and-analysis': 'Financial Planning and Analysis',
      'accounting-and-financial-close': 'Accounting and Financial Close',
      'treasury-management': 'Treasury Management',
      'accounts-receivable-billing-and-revenue-management': 'Accounts Receivable, Billing, and Revenue Management',
      'governance-risk-compliance-and-cybersecurity': 'Governance, Risk, Compliance (GRC), and Cybersecurity',
      // CRM and Customer Experience
      'customer-data': 'Customer Data',
      marketing: 'Marketing',
      commerce: 'Commerce',
      sales: 'Sales',
      service: 'Service',
      // 'Network and Spend Management',
      'supplier-management': 'Supplier Management',
      'sourcing-and-contracts': 'Sourcing and Contracts',
      procurement: 'Procurement',
      'external-workforce-and-services': 'External Workforce and Services',
      'invoices-and-payments': 'Invoices and Payments',
      'travel-and-expense': 'Travel and Expense',
      // 'Supply Chain Management',
      'supply-chain-planning': 'Supply Chain Planning',
      'supply-chain-logistics': 'Supply Chain Logistics',
      manufacturing: 'Manufacturing',
      'product-lifecycle-management': 'Product Lifecycle Management',
      'enterprise-asset-management': 'Enterprise Asset Management',
      // Human Capital Management
      'employee-experience-management': 'Employee Experience Management',
      'core-hr-and-payroll': 'Core HR and Payroll',
      'talent-management': 'Talent Management',
      'hr-analytics-and-workforce-planning': 'HR Analytics and Workforce Planning',
      //     'Business Technology Platform'
      'database-and-data-management': 'Database and Data Management',
      'application-development-and-automation': 'Application Development and Automation',
      analytics: 'Analytics',
      'intelligent-technologies': 'Intelligent Technologies'
    }
  },
};
